import React from 'react';
import { Button, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MainTextField from '../MainTextField';

import useStyles from './makeStyles';

const InputWithButton = ({ value, onChange, placeholder, handleClick }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container className={classes.root}>
      <Grid item xs={8}>
        <MainTextField
          variant="outlined"
          fullWidth
          size="small"
          placeholder={placeholder}
          className={classes.input}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
      </Grid>
      <Grid item xs={4}>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          fullWidth
          size="small"
          className={classes.button}
          onClick={handleClick}
        >
          {t('promoCode.apply')}
        </Button>
      </Grid>
    </Grid>
  );
};

InputWithButton.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  handleClick: PropTypes.func,
  onChange: PropTypes.func,
};

InputWithButton.defaultProps = {
  value: '',
  onChange: () => {},
  placeholder: '',
  handleClick: () => {},
};

export default InputWithButton;
